export const formatErrorMessages = (error: any): JSX.Element => {
	const errorMessage = error?.response?.data?.data?.errors || [error?.response?.data?.message];

	const messages = Object.values(errorMessage || {}).flat() as string[];

	return (
		<ul>
			{messages.map((msg, index) => (
				<li key={index}>{msg}</li>
			))}
		</ul>
	);
};
